/**
 * AWS Secrets Manager ARN validation for UUP delivery credentials.
 *
 * Example from deliveries team:
 * arn:aws:secretsmanager:us-east-1:992173438675:secret:uup/<client-name>/s3_creds
 */
export const SECRETS_MANAGER_ARN_PATTERN =
  /^arn:aws:secretsmanager:[a-z0-9-]+:\d{12}:secret:[\w/+=.@!-]+$/

export const SECRETS_MANAGER_ARN_EXAMPLE =
  'arn:aws:secretsmanager:<region>:<account-id>:secret:uup/<client-name>/s3_creds'

export const SECRETS_MANAGER_ARN_INVALID_MESSAGE =
  'Enter a valid Secrets Manager ARN (region, 12-digit account ID, and secret name — e.g. uup/<client-name>/s3_creds)'

export function isValidSecretsManagerArn(value) {
  return SECRETS_MANAGER_ARN_PATTERN.test(String(value || '').trim())
}
